import axios from 'axios';

import __CFG from '@/conf/config.json';

import * as __modal_details from '@/modal_details.js';

import { bus } from '@/main';

import loanStore from '@/stores/loanStore';


const instance = axios.create({
  baseURL: __CFG.primaryEndpoint,
  timeout: 35000,
  withCredentials: true
});


export default {


  data: function () {
    return {

      minAmount: this.getConf('min_amount'),
      minTenor: this.getConf('min_tenor'),

      errors: null

    }
  },


  computed: {
    loanAmount: {
      get() { return loanStore.loanAmount; },
      set(v) { loanStore.loanAmount = v; }
    },
    loanTenor: {
      get() { return loanStore.loanTenor; },
      set(v) { loanStore.loanTenor = v; }
    },
    tenorSign: {
      get() { return loanStore.tenorSign; },
      set(v) { loanStore.tenorSign = v; }
    },
    total: {
      get() { return loanStore.total; },
      set(v) { loanStore.total = v; }
    },
    interest: {
      get() { return loanStore.interest; },
      set(v) { loanStore.interest = v; }
    },
    commission: {
      get() { return loanStore.commission; },
      set(v) { loanStore.commission = v; }
    },
    service: {
      get() { return loanStore.service; },
      set(v) { loanStore.service = v; }
    },
    insurance: {
      get() { return loanStore.insurance; },
      set(v) { loanStore.insurance = v; }
    },
    rrso: {
      get() { return loanStore.rrso; },
      set(v) { loanStore.rrso = v; }
    },
    dailyInterest: {
      get() { return loanStore.dailyInterest; },
      set(v) { loanStore.dailyInterest = v; }
    },
    nbpInterest: {
      get() { return loanStore.nbpInterest; },
      set(v) { loanStore.nbpInterest = v; }
    },
    finishDate: {
      get() { return loanStore.finishDate; },
      set(v) { loanStore.finishDate = v; }
    }
  },


  directives: {
    dynamic: {
      bind(el, binding, vn) {
        el.innerHTML = binding.value;
      },
      update(el, binding) {
        el.innerHTML = binding.value;
      },
    },
  },



  methods: {

    passwordPolicy(v){
      return (/(?=.*\d)/.test(v) ? 1 : 0) + (/(?=.*[a-z])/.test(v) ? 1 : 0) + (/(?=.*[A-Z])/.test(v) ? 1 : 0) + (/(?=.*\W)/.test(v) ? 1 : 0) >= 3 ;
    },

    get(route, queryParameters = null, opt ={} ) {
      return this._sendRequest(instance.get(route, { params: queryParameters, ...opt}));
    },
    post(route, parameters = null, queryParameters = null) {
      return this._sendRequest(instance.post(route, parameters, { params: queryParameters }));
    },
    put(route, parameters = null, queryParameters = null) {
      return this._sendRequest(instance.put(route, parameters, { params: queryParameters }));
    },
    delete(route, parameters = null, queryParameters = null) {
      return this._sendRequest(instance.delete(route, parameters, { params: queryParameters }));
    },
    patch(route, parameters = null, queryParameters = null) {
      return this._sendRequest(instance.patch(route, parameters, { params: queryParameters }));
    },
    _sendRequest(request) {
      return new Promise((resolve, reject) => {
        request.then(response => {
          resolve(response)
        }).catch(error => {
          this._errorResponse(error, reject);
        });
      });
    },


    // Widok bledu axios do logu BEZ request body (config.data) - pelny obiekt
    // niosl plaintext hasla z /client/login i /client/password do .jsonl
    // (znalezione 2026-10-11 w logach prod). Klucze data/status/url zachowane,
    // bo po nich grepuja skrypty analizy.
    _safeErr(error) {

      if (!error || typeof error != 'object') {

        return error;
      }

      let cfg = error.config || {},
          r = error.response || null;

      return {
        message: error.message,
        url: cfg.url,
        method: cfg.method,
        status: r ? r.status : null,
        data: r ? r.data : null
      };
    },


    // kopia obiektu do logu z zamaskowanymi haslami (client_password,
    // password_confirm, passwd...) - payload /application w trybie OTP niesie
    // haslo ustawiane na kroku 1, a log "request params" szedl do .jsonl w calosci
    maskSecrets(ob) {

      if (!ob || typeof ob != 'object') {

        return ob;
      }

      let out = Array.isArray(ob) ? [] : {};

      Object.keys(ob).map(k => {

        out[k] = /pass/i.test(k) && ob[k] ? '***' : ob[k];
      });

      return out;
    },


    _errorResponse(error, reject) {

      // send log
      if (typeof error != 'object') {

        this.log('not object', error);
      }
      else {

        if ( error.config.url.match('session') && error.response.status == 403 ) {

        }
        else {

          this.log('request error', ' response is ', this._safeErr(error));
        }
      }



      if (!error) {
        reject(error);
        return;
      }



      let dt = typeof error == 'object' && (dt = error.response) && dt.data;


      if (!dt) {

        this.log('_errorResponse handler', ' details ', this._safeErr(error));

        reject(error);
        return;
      }


      this.log('_errorResponse handler', ' details ', this._safeErr(error));




      switch(error.response.status) {
        case 401:
          // Permission Error (logout)
          break;

        case 402:
          // Your account is expired, (redirect to BUY)
          break;

        case 403:
          // forbidden
          Object.keys(dt).map(k => {

            if (k.match(/ERROR/)) {
              this.errors = dt[ k ];
            }
          });

          reject(error);
          break;

        case 422:
          // this is a validation error

          Object.keys(dt).map(k => {

            if (k.match(/Message/)) {

              this.errors = dt[ k ];
            }
          });

          reject(error);
          break;

        default:
          error.message = error.response.data.message;
          reject(error);
          break;
      }


      // if not matched any type of error
      if (!this.errors) {
        this.errors = 'Wystąpił błąd!';
      }
    },


    log: function() {
      if (window.LogService) {
        window.LogService.log.apply(window.LogService, arguments);
        return;
      }

      // Fallback jeśli LogService nie gotowy
      console.log.apply(console, ['[LOG]'].concat(Array.prototype.slice.call(arguments)));
    },


    getConf(key){

      return __CFG.hasOwnProperty(key) ? __CFG[ key ] : null;
    },


    pageTop(){

      // get form element id
      let el = document.querySelector('div.main-col');

      if (!!el) {

        setTimeout(() => {
          el.scrollIntoView();
        }, 500);

      }
      else {

        setTimeout(() => {
          window.scrollTo(0,0);
        }, 500);

      }
    },


    toast(msg='') {

      this.$toasted.show(msg,{
           theme: "bubble",
           position: "top-right",
           className: 'toster',
           duration : 1500
        });
    },

    // disable / enable window scroll
    scrollFreeze(disable=true){

      if (disable) {

        var x=window.scrollX;
        var y=window.scrollY;
        window.onscroll=function(){window.scrollTo(x, y);};
      }
      else {
        window.onscroll=null;
      }
    },

    echo(name='default', ...args){

      bus.$emit(name, ...args);
    },


    listen(name='default', callback=null){

      bus.$on(name, callback);
    },

    unlisten(name='default', callback=null){

      bus.$off(name, callback);
    },

    canApplyForLoan(user) {

      return !!parseInt(user.verified)
        && String(user.client_status).indexOf('Karencja') === -1
        //&& !parseInt(user.rejected_in_24);
    },


    // set loan params values
    setValues(v=null, t='30', s='d'){

      v = parseFloat(v);

      if (!this.loan_params.hasOwnProperty(String(t+s))) {
          t = this.minTenor;
          v = this.minAmount;
          s = this.tenorSign;
      }

      if ( this.loan_params.hasOwnProperty(String(t+s)) && this.loan_params[t+s].hasOwnProperty(String(v)) ){

        let dat = this.loan_params[t+s][v],
            now = new Date(),
            newDate = s == 'm' ? new Date(now.setMonth(now.getMonth() + t)) : new Date(Date.now() + t * 24*60*60*1000),
            iso = newDate.toISOString();

        this.loanAmount = v;
        this.loanTenor = t;
        this.tenorSign = s;

        this.total = dat[1];

        this.interest = dat[2];
        this.service = dat[3];
        this.commission = dat[4];
        this.insurance = dat[5];
        this.rrso = dat[6];

        this.dailyInterest = parseInt(this.interest) / 30;

        this.nbpInterest = ((parseFloat(this.loanAmount) * 0.23) / 365).toFixed(2);

        this.finishDate = iso.split('T')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');
      }
    },



    getModalContent(name){

      if (!__modal_details[name]) {
        return 'no data';
      }


      switch (name) {

        case 'info_form':

        let             now = new Date(),
                        tom = new Date(Date.now() + this.loanTenor * 24*60*60*1000),
                        today = now.toISOString().split('T')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1'),
                        tomorrow = tom.toISOString().split('T')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');


          return [
            ['{m%POZYCZKA.KAPITAL}', this.loanAmount],
                    ['{m%POZYCZKA.CALKOWITA_KWOTA_DO_SPLATY}', this.total],

                    ['{POZYCZKA.OPROCENTOWANIE_STOPA}', this.getConf('nbp_interest_rate')],
                    ['{m%POZYCZKA.OPROCENTOWANIE_STOPA}', this.getConf('nbp_interest_rate')],
                    ['{POZYCZKA.STOPA_NBP}', this.getConf('nbp_penalty_rate')],
                    ['{m%POZYCZKA.STOPA_NBP}', this.getConf('nbp_penalty_rate')],
                    ['{POZYCZKA.PRZYKLAD}', this.getConf('loan_sample')],
                    ['{POZYCZKA.PRZYKLAD_KWOTA}', this.getConf('sample_amount')],
                    ['{POZYCZKA.PRZYKLAD_PROWIZJA}', this.getConf('sample_fee')],
                    ['{POZYCZKA.PRZYKLAD_ODSETKI}', this.getConf('sample_interest')],
                    ['{POZYCZKA.PRZYKLAD_OBSLUGA}', this.getConf('sample_service')],
                    ['{POZYCZKA.PRZYKLAD_KOSZT}', this.getConf('sample_cost')],
                    ['{POZYCZKA.PRZYKLAD_RRSO}', this.getConf('sample_rrso')],
                    ['{POZYCZKA.PRZYKLAD_DATA}', this.getConf('sample_valid_from')],
                    ['{POZYCZKA.PRZYKLAD_CALKOWITA_KWOTA}', this.getConf('sample_total')],

                    ['{POZYCZKA.LICZBA_DNI}', this.loanTenor],
                    ['{POZYCZKA.DATA_SPLATY}r.', this.finishDate+'r.'],
                    ['{POZYCZKA.OPLATA_POCZATKOWA}', this.commission],
                    ['{m%POZYCZKA.OPLATA_POCZATKOWA}', this.commission],
                    ['{POZYCZKA.OPROCENTOWANIE}', this.interest],
                    ['{m%POZYCZKA.OPROCENTOWANIE}', this.interest],
                    ['{m%POZYCZKA.OPLATA_POCZATKOWA_PLUS_POZYCZKA.OPLATA_ZA_OBSLUGE}', this.commission+this.service],

                    ['{POZYCZKA.ODSETKI_DZIENNE}', parseFloat(this.dailyInterest).toFixed(2)],
                    ['{m%POZYCZKA.ODSETKI_DZIENNE}', parseFloat(this.dailyInterest).toFixed(2)],

                    ['{POZYCZKA.KOSZT}', this.service + this.interest + this.commission],

                    ['{POZYCZKA.LICZBA_RAT}', 1],
                    ['{POZYCZKA.OKRES}', 1],
                    ['{m%POZYCZKA.KWOTA_RATY}', (this.total/ 1).toFixed(2)],
                    ['{POZYCZKA.RRSO}', this.rrso+' '],
                    ['{POZYCZKA.DATA_UMOWY}', today],
                    ['{POZYCZKA.DATA_WNIOSKU}', today],
                    ['{POZYCZKA.DATA_SPLATY}', this.finishDate],
                    ['{POZYCZKA.DATA_WNIOSKU_PLUS_1D}', tomorrow],
                    ['{m%POZYCZKA.OPLATA_ZA_OBSLUGE}', this.service],

                    ['{POZYCZKA.ODSETKI_DZIENNE_NBP}', this.nbpInterest]

          ]
          .reduce((acc, itm) => acc.replaceAll(new RegExp(itm[0], 'g'), itm[1]), __modal_details[ name ]);



        default:
          return __modal_details[ name ];
      }

    },


    copyToClipboard (event) {

      let target = 'string' == typeof event ? document.getElementById(event) : (event.target.tagName == 'I' ? event.target.parentNode : event.target);

      var textArea;

      function isOS() {
        return navigator.userAgent.match(/ipad|iphone/i);
      }

      function createTextArea(text) {
        textArea = document.createElement('textArea');
        textArea.readOnly = true;
        textArea.contentEditable = true;
        textArea.value = text;
        document.body.appendChild(textArea);
      }

      function selectText() {
        var range, selection;

        if (isOS()) {
          range = document.createRange();
          range.selectNodeContents(textArea);
          selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
          textArea.setSelectionRange(0, 999999);
        } else {
          textArea.select();
        }
      }

      function copyTo() {
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }

      createTextArea(target.innerText);
      selectText();
      copyTo();

      this.toast('Skopiowano!');
    },



    formatCurrency: function(num, noDecimals=true, addCurrencySign=false, noEmptyCents=true) {
        var cents, sign;

        num = String(num).replace(/\$|\,/g,'');

        if(isNaN(num))
          num = "0";

        sign = (num == (num = Math.abs(num)));
        num = Math.floor(num*100+0.50000000001);
        cents = num%100;
        num = Math.floor(num/100).toString();

        if(cents<10)
          cents = "0" + cents;

        for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
          num = num.substring(0,num.length-(4*i+3)) + ' ' + num.substring(num.length-(4*i+3));

       return (
             ((addCurrencySign) ? '<span class="currency-format-sign">' + '_CURRENCY_SIGN_'.t() + '</span> ' : '')
           + ((sign)?'':'-')
          + (parseInt(num) == 0 && String(cents).match(/00/) ? '<span class="currency-format-value-zero">'+ num + '</span>' : num )
          + ((noDecimals) ? '' : ((String(cents).match(/00/) ? (noEmptyCents ? ',00' : ''
              ) : ','+cents)))


       );
      },


      // polski numer komorkowy: 9 cyfr, prefiks 45/5x/6x/7x/88 - bez wiodacego 0,
      // +48 i numerow stacjonarnych 1x-3x/9x. Incydent 2026-10-07: 073504558
      // przeszlo maske #########, smsapi odrzucil wysylke kodu, a wniosek poszedl dalej.
      // Ta sama regula po stronie BFF (IndexController::isPlMobile).
      isPlMobile(input) {

        var digits = String(input == null ? '' : input).replace(/\D/g, '');

        return /^[4-8][0-9]{8}$/.test(digits);
      },


      /*
       * Returns 1 if the IBAN is valid
       * Returns FALSE if the IBAN's length is not as should be (for CY the IBAN Should be 28 chars long starting with CY )
       * Returns any other number (checksum) when the IBAN is invalid (check digits do not match)
       */
      isValidIBAN(input) {

        // polish validation
        input = 'PL' + input;

          var CODE_LENGTHS = {
              AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
              CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
              FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
              HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
              LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
              MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
              RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26,
              AL: 28, BY: 28, CR: 22, EG: 29, GE: 22, IQ: 23, LC: 32, SC: 31, ST: 25,
              SV: 28, TL: 23, UA: 29, VA: 22, VG: 24, XK: 20
          };
          var iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''),
                  code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/),
                  digits;
          // check syntax and length
          if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
              return false;
          }
          // rearrange country code and check digits, and convert chars to ints
          digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
              return letter.charCodeAt(0) - 55;
          });

          // final check
          return this.mod97(digits) === 1;
      },

      mod97(string) {
          var checksum = string.slice(0, 2), fragment;
          for (var offset = 2; offset < string.length; offset += 7) {
              fragment = String(checksum) + string.substring(offset, offset + 7);
              checksum = parseInt(fragment, 10) % 97;
          }
          return checksum;
      }


  },


  created() {

  }


};



// WEBPACK FOOTER //
// ./src/mixins/common.js